"use client";

import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@repo/design-system/components/ui/skeleton";
import { useFilterSearch } from "@repo/design-system/hooks/use-filter-search";
import { useLocale } from "@repo/design-system/hooks/use-locale";
import { filterTypes as by } from "@repo/design-system/types/filter";
import dynamic from "next/dynamic";
import { env } from "~/setup/env";
import { useLanguage } from "~/translations/loader/use-language";
import { ClearFilters } from "../../filterbar/clear-filters";
import { GeoSelect } from "../../filterbar/filters/geo-select-eon";
import { GroupSelect } from "../../filterbar/filters/group-select-eon";
import { LocationSelect } from "../../filterbar/filters/location-select-eon";
import { MultiSelect } from "../../filterbar/filters/multi-select";
import { Searchbar } from "../../filterbar/searchbar-eon";
import { ToggleMap } from "../../filterbar/toggle-map-eon";
const WatchJobs = dynamic(() => import("../../filterbar/watch-jobs-eon").then(m => m.WatchJobs), {
  ssr: false,
  loading: () => <Skeleton className="h-12" />
});

/**
 * Grid Solutions job-board filter bar (legacy Filterbar.eon.eongrid): headline with hit count,
 * no company / language filters, no newsletter CTA.
 */
export default function FilterbarEonGridsolutions() {
  const $ = _c(40);
  const t = useLanguage();
  const locale = useLocale();
  const {
    data
  } = useFilterSearch();
  const totalHits = data?.pages[0].totalHits ?? 0;
  const tagline = totalHits === 1 ? t.filterbar_taglineSingular : t.filterbar_tagline;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      backgroundImage: `url(${env.NEXT_PUBLIC_ASSET_URL}images/jobboard/filterbar_pattern.png)`,
      backgroundSize: "cover",
      backgroundPosition: "center"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== locale || $[2] !== totalHits) {
    t1 = totalHits.toLocaleString(locale);
    $[1] = locale;
    $[2] = totalHits;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1 || $[5] !== tagline) {
    t2 = <h1 className="font-bold text-5xl md:mb-2"><span>{t1} {tagline} E.ON Grid Solutions</span></h1>;
    $[4] = t1;
    $[5] = tagline;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t.aria_header_filterbar) {
    t3 = <h2 className="sr-only">{t.aria_header_filterbar}</h2>;
    $[7] = t.aria_header_filterbar;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Searchbar />;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t.filterbar_geosearch_label) {
    t5 = <div className="grid grid-flow-row items-center gap-x-4 gap-y-4 md:grid-cols-2">{t4}<GeoSelect label={t.filterbar_geosearch_label} /></div>;
    $[10] = t.filterbar_geosearch_label;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [by.JOB_FIELD];
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t.filterbar_filter4_placeholder) {
    t7 = <MultiSelect filterBy={t6} id="1" label={t.filterbar_filter4_placeholder} />;
    $[13] = t.filterbar_filter4_placeholder;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [by.ENTRY_LEVEL_MULTI];
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t.filterbar_filter2_placeholder) {
    t9 = <MultiSelect filterBy={t8} id="2" label={t.filterbar_filter2_placeholder} />;
    $[16] = t.filterbar_filter2_placeholder;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = [by.EMPLOYMENT_TYPE, by.CONTRACT];
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t.filterbar_filter3_placeholder) {
    t11 = <GroupSelect filterBy={t10} id="3" label={t.filterbar_filter3_placeholder} />;
    $[19] = t.filterbar_filter3_placeholder;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = [by.REMOTE];
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t.filterbar_filter7_placeholder) {
    t13 = <MultiSelect filterBy={t12} id="4" label={t.filterbar_filter7_placeholder} />;
    $[22] = t.filterbar_filter7_placeholder;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t.filterbar_filter1_placeholder) {
    t14 = <LocationSelect id="6" label={t.filterbar_filter1_placeholder} />;
    $[24] = t.filterbar_filter1_placeholder;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  let t16;
  let t17;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <WatchJobs />;
    t16 = <ToggleMap />;
    t17 = <ClearFilters className="xl:col-start-4" />;
    $[26] = t15;
    $[27] = t16;
    $[28] = t17;
  } else {
    t15 = $[26];
    t16 = $[27];
    t17 = $[28];
  }
  let t18;
  if ($[29] !== t11 || $[30] !== t13 || $[31] !== t14 || $[32] !== t7 || $[33] !== t9) {
    t18 = <div className="grid grid-flow-row items-center gap-x-4 gap-y-4 md:grid-cols-2 xl:grid-cols-4">{t7}{t9}{t11}{t13}{t14}{t15}{t16}{t17}</div>;
    $[29] = t11;
    $[30] = t13;
    $[31] = t14;
    $[32] = t7;
    $[33] = t9;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== t18 || $[36] !== t2 || $[37] !== t3 || $[38] !== t5) {
    t19 = <section className="grid w-full justify-items-center px-6 py-6 text-background text-lg md:px-10 md:py-20" id="filterbar" style={t0} tabIndex={-1}><div className="inner-container grid w-full max-w-screen-xl gap-y-4">{t2}{t3}{t5}{t18}</div></section>;
    $[35] = t18;
    $[36] = t2;
    $[37] = t3;
    $[38] = t5;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  return t19;
}